











import { Component, Vue } from 'vue-property-decorator'
import EnergyConsumptionMenu from '@/components/EnergyConsumptionMenu'

@Component({
    components:{
        EnergyConsumptionMenu
    }
})
export default class Login  extends Vue {

}
